/**
 * The languages Trainy ships, and the one place to say so on the client.
 *
 * Adding a language is three steps:
 *   1. add an entry here,
 *   2. put the matching `src/i18n/locales/<code>/*.json` files in place and
 *      register them in `./resources.ts`, and
 *   3. add the code to `languageValidator` in convex/lib/validators.ts and to
 *      the email dictionaries in convex/lib/authEmailTemplates.ts and
 *      convex/lib/reportEmailCopy.ts.
 */
export const LANGUAGES = [
  { code: "en", endonym: "English" },
  { code: "fr", endonym: "Français" },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export const SUPPORTED_LANGUAGE_CODES: LanguageCode[] = LANGUAGES.map(
  (language) => language.code,
);

export const DEFAULT_LANGUAGE: LanguageCode = "en";

// Where the language chosen before signing in is remembered.
export const LANGUAGE_STORAGE_KEY = "trainy_lang";

/** Narrows any value to a supported language code, or `undefined`. */
export function asLanguageCode(value: unknown): LanguageCode | undefined {
  if (typeof value !== "string") return undefined;
  const code = value.toLowerCase().slice(0, 2);
  return (SUPPORTED_LANGUAGE_CODES as string[]).includes(code)
    ? (code as LanguageCode)
    : undefined;
}
